
import {Injectable} from '@angular/core';

@Injectable()

export class Global{
    lang: string = 'fa';
}


// WEBPACK FOOTER //
// ./src/app/components/global.ts